var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-center mt-8 w-100 justify-center d-flex" },
    [
      _c("div", { staticClass: "container-empty" }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "mb-4 mt-4" },
            [
              _c("font-awesome-icon", {
                staticClass: "download-icon",
                attrs: { icon: "fa-folder" },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "text-subtitle-1 mb-2" }, [
            _vm._v(" " + _vm._s(_vm.title) + " "),
          ]),
          _c("div", { staticClass: "text-body-2 grey--text" }, [
            _vm._v(" " + _vm._s(_vm.description) + " "),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }